/**
 * The mark's geometry, in MODULES.
 *
 * A module is the narrowest bar. Every width below is a multiple of it, and the
 * SVG carries no `preserveAspectRatio="none"` — the first build had one, which
 * stretched the bars to whatever box they landed in, so the same code came out a
 * different shape on every screen. A barcode whose proportions depend on its
 * container is not a barcode.
 */
export const ONDO_CODE = {
  /** Bar height, before the guard extension. */
  height: 36,
  /** How much further the guards run below the bars, EAN-style. */
  guardExtend: 5,
  /** Room to the left for 'OND', which sits outside the bars as EAN's leading digit does. */
  prefix: 13,
  /** Between the code and its add-on. Wide enough that they read as two symbols. */
  addOnGap: 8,
  /**
   * The quiet zone. A barcode's margin is part of the symbol, not padding —
   * without it a scanner (or an eye) cannot tell where the code stops.
   */
  quiet: 3,
  /** The add-on's bars start lower, so its caption has room above them. */
  addOnTop: 9,
  /** Space under everything for the printed state word. */
  wordBand: 7,
  text: {
    prefix: 4.2,
    payload: 5.2,
    caption: 4.2,
    word: 5,
  },
} as const;
